export const scrollToId = (id) => {
  if (window.location.pathname !== "/" && window.__navigate) {
    window.__navigate("/", { state: { scrollTo: id } });
    return;
  }
  const el = document.querySelector(id.startsWith("#") ? id : `#${id}`);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -70, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
